import { get, post } from "../api_helper";

const GetAllAppointments = async () => {
  const url = "get-appointments";
  const response = await get(url);
  return response;
};

const GetAllUserAppointment = async () => {
  const url = "get-user-appointments";
  const response = await get(url);
  return response;
};

const GetAppointmentDetails = async (appointmentId) => {
  const url = `get-appointment-details?appointmentId=${appointmentId}`;
  const response = await get(url);
  return response;
};

export { GetAllAppointments, GetAllUserAppointment, GetAppointmentDetails };
